module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_8004.3acf9098.png";